<script>
import moment from 'moment';
import base_endpoint from '../services/domainApp';
import { mapActions } from 'vuex';
export default {
    data() {
        return {
            booking: null,
            url_app: base_endpoint,
            load: false
        }
    },
    methods: {
        closed() {
            this.load = true;
            this.booking = null;
            this.$modal.toggle('ModalBooking');
        },
        async copyClipboard(text) {
            navigator.clipboard.writeText(text)
                .then(async () => {
                    await this.successNotification('Texto copiado');
                })
                .catch(async (error) => {
                    this.errors = await this.errorNotification(error)
                });
        },
        generateMessage(data, action) {
            let vm = this;
            const url = this.url_app;

            const report_reciever = `${url}/report/${data.reservation_number}/1`;
            const report_delivery = `${url}/report/${data.reservation_number}/2`;
            const assistant = `${url}/assistant/${data.reservation_number}`;
            const control_assistant = `${url}/control_assistant/${data.reservation_number}`;

            const _text = `_¡Tu reserva se ha realizado con éxito!._\n\nFavor de validar que los datos de tu reserva sean correctos: \n\n*${data.course ? data.course.name : ''}*\n*Centro de Experiencia:* ${data.room.name} \n*Día:* ${moment(data.date).format('LL')} \n*Horario:* ${moment(data.time_start, 'HH:mm').format('h:mm A')} a ${moment(data.time_end, 'HH:mm').format('h:mm A')}\n\n*¡IMPORTANTE!* Para garantizar un adecuado uso, mantenimiento y control de la sala, es necesario que realices lo siguiente:\n\n*1.	RECEPCIÓN DE SALA (Antes de la Sesión)*\nIngresa a la siguiente liga y en conjunto con el responsable del Centro de Experiencia validen el estado en que recibes la Sala (Evita quedar como responsable de cualquier desperfecto):${report_reciever}\n\n*2.	REGISTRO DE ASISTENCIA (Al Cierre de la Sesión)*\nIngresa a esta liga y comparte con los participantes el Código QR para que registren su Asistencia (Valida que todos lo hagan en la misma liga:${assistant}\n\nLiga QR y control de asistencia: ${control_assistant}\n\n*3.	ENTREGA DE SALA (Después de la Sesión)*\nEn compañía al responsable del Centro de Experiencia, Ingresa a la liga anexa y validen juntos el estado de la sala y la funcionalidad de las amenidades:${report_delivery} \n\n¡Nos vemos pronto!`;
            
            // función para copiar el texto en el portapapeles
            if (action == 'copy') {
                vm.copyClipboard(_text);
            } else if (action == 'share') {
                vm.captureAndShare(_text);
            }
            //vm.copyClipboard(_text);
        },
        async captureAndShare(text) {

            const encodeText = encodeURIComponent(text);

            // Construye el enlace de intercambio de WhatsApp
            const whatsappLink = `https://api.whatsapp.com/send?text=${encodeText}`;

            // Abre la ventana de WhatsApp con el enlace de intercambio
            window.open(whatsappLink, '_blank');
        },
        ...mapActions({
            errorNotification: 'alert/error',
            successNotification: 'alert/success',
        }),
    },
    created() {
        Event.$on("event-show-booking", (booking) => {
            this.booking = booking;
            this.$modal.toggle('ModalBooking');
        });
    },
}
</script>
<template>
    <modal name="ModalBooking" :width="'95%'" :maxWidth="700" :adaptive="true" :shiftY="0.2">
        <div class="row">
            <div class="col-12 pl-5 pr-5 pb-5 pt-4">
                <div class="row" v-if="booking">
                    <div class="col-12">
                        <button @click="closed()" class="btn float-right btn-sm rounded-r btn-danger">
                            <i class="fa fa-times"></i>
                        </button>
                        <h3>Datos de la reserva </h3>
                        <hr>
                    </div>
                    <div class="col-md-6 mt-2 col-12">
                        <h5 class="text-danger"># Reserva: {{ booking.reservation_number }}</h5>
                    </div>
                    <div class="col-md-6 mt-2 col-12 text-right" v-if="booking.status == 1">
                        <button class="btn btn-wath pr-3" @click="generateMessage(booking, 'share')">
                            <i class="fa-brands fa-whatsapp mr-1 ml-1"></i>
                            Compartir
                        </button>
                        <button class="btn btn-secondary rounded-r2 pr-3" @click="generateMessage(booking, 'copy')"><i class="fas fa-copy mr-1 ml-1"></i>Copiar mensaje</button>
                    </div>
                    <div class="col-md-12 mt-2 col-12">
                        <h6>Fecha :</h6>
                        <span v-if="booking.date == booking.date_departure">
                            {{ booking.date | toDateTime }}
                        </span>
                        <span v-else>
                            {{ booking.date | toDateTime }}
                            <span v-if="booking.date_departure"> - {{ booking.date_departure | toDateTime }} </span>
                        </span>
                    </div>

                    <div class="col-md-6 mt-2 col-12">
                        <h6>Sala :</h6>
                        {{ booking.room.name }}
                    </div>

                    <div class="col-md-6 mt-2 col-12">
                        <h6>Horario :</h6>
                        {{ booking.time_start }} - {{ booking.time_end }}
                    </div>
                    <div class="col-md-6 mt-2 col-12" v-if="booking.user">
                        <h6>Código :</h6>
                        {{ booking.user.code_user }}
                    </div>
                    <div class="col-md-6 mt-2 col-12" v-if="booking.user">
                        <h6>Nombre :</h6>
                        <span v-if="booking.user.full_name">
                            {{ booking.user.full_name }}
                        </span>
                        <span v-else>
                            {{ booking.user.first_name }} {{ booking.user.last_name }}
                        </span>
                    </div>
                    <div class="col-md-6 mt-2 col-12" v-if="booking.user">
                        <h6>Email :</h6>
                        {{ booking.user.email }}
                    </div>
                    <div class="col-md-6 mt-2 col-12">
                        <h6>Participantes :</h6>
                        {{ booking.participants }} Asistente<span v-if="booking.participants > 1">s</span>
                    </div>
                    <!-- <div class="col-md-6 mt-2 col-12">
                        <h6>UDN :</h6>
                        {{ booking.udn ? booking.udn.name : '---' }}
                    </div> -->
                    <div class="col-md-6 mt-2 col-12">
                        <h6>Curso :</h6>
                        {{ booking.course ? booking.course.name : '---' }} {{ booking.course_other ? ' - ' +
                            booking.course_other : '' }}
                    </div>
                    <div class="col-md-6 mt-2 col-12">
                        <h6>Temas :</h6>
                        {{ booking.topic }}
                    </div>
                    <div class="mt-2 col-12">
                        <h6 class=" pb-2">Amenidades de la sala :</h6>
                        <div class="row">
                            <div class="col-md-4 pt-3 pb-3 col-6 text-center"
                                v-for="(amenitie, index_amenitie) in booking.room.amenities" :key="index_amenitie">
                                <i class="fa-2xl pb-3" :class="amenitie.preference.icon"></i><br>
                                <span style="font-size: 14px;">{{ amenitie.preference.name }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 text-center mt-2 col-12">
                        <hr>
                        <button @click="closed()" style="width: 200px;" class="btn rounded-r btn-danger">
                            Cerrar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>
<style>
.head-modal {
    background-image: url('@/assets/img/fondo_01.jpg');
    height: 150px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}

.rounded-r {
    border-radius: 20px !important;
}</style>